// extracted by mini-css-extract-plugin
export default {"PricingCardWrapper":"PricingCardWrapper_PricingCardWrapper__Hpoxe","dashboard":"PricingCardWrapper_dashboard__Mc-hg","Content":"PricingCardWrapper_Content__Km76l"};